import { ThemeOptions as DeprecatedThemeOptions } from '@material-ui/core';
import { ThemeOptions } from '@mui/material';

export const PRIMARY_MAIN = '#10243b';
export const SECONDARY_MAIN = '#a71e21';

export const TEXT_DARK_COLOR = '#d3e5fd';
export const TEXT_LIGHT_COLOR = '#10243b';

const TEXT_BASE_SIZE = 15;

export const customPalette: ThemeOptions & DeprecatedThemeOptions = {
  palette: {
    mode: 'light',
    contrastThreshold: 3.4,

    background: {
      default: '#ffffff',
      light: '#f8f8f8',
      lightBlue: '#236B90',
      dark: '#292929',
    },

    primary: {
      main: PRIMARY_MAIN,
      dark: PRIMARY_MAIN, // colorSchema.primary
      side: '#10243b', // colorSchema.sidebar
      sideFont: '#d3e5fd', // colorSchema.sidebarFont
      light: '#61a5f7', // colorSchema.accent2
    },

    secondary: {
      main: SECONDARY_MAIN,
      light: '#10243b', // colorSchema.accent1
    },

    white: '#FFFFFF',
    muted: '#d2d2d2',
    border: '#E7E7E7',
    borderlight: '#DBDBDB',
    borderGrey: '#f4f4f4',
    text: { primary: '#212121', secondary: '#8B8B8B', light: '#9B9B9B' },

    success: { main: '#01B9A1' },
    error: { main: '#EF5C5C' },
    warning: { main: '#FFC107' },
  },

  typography: {
    fontFamily: 'Barlow',
    fontSize: TEXT_BASE_SIZE,
    htmlFontSize: TEXT_BASE_SIZE,

    h1: {
      fontSize: '3rem',
      fontWeight: 600,
    },

    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },

    h3: {
      fontSize: '2rem',
      fontWeight: 600,
    },

    h4: {
      fontSize: '1.8rem',
      fontWeight: 500,
    },

    h5: {
      fontSize: '1.6rem',
      fontWeight: 500,
    },

    h6: {
      fontSize: '1.2rem',
      fontWeight: 500,
    },

    subtitle1: {
      fontSize: '1.8rem',
      fontWeight: 600,
    },

    subtitle2: {
      fontSize: '1.6rem',
      fontWeight: 500,
    },

    subtitle3: {
      fontSize: '1.6rem',
      fontWeight: 500,
    },

    subtitle4: {
      fontSize: '1.2rem',
      fontWeight: 500,
    },

    subtitle5: {
      fontSize: '1rem',
      fontWeight: 500,
    },

    body1: {
      fontSize: TEXT_BASE_SIZE,
      lineHeight: 1.5,
    },
  },

  spacing: 8,

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },

  components: {
    MuiLink: {
      defaultProps: {
        color: 'secondary',
      },

      styleOverrides: {
        root: {
          cursor: 'pointer',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        sizeLarge: ({ theme }) => ({
          minHeight: '3.5rem',
          fontSize: theme.typography.body1.fontSize,
        }),
      },
    },
  },

  overrides: {
    MuiLink: {
      root: {
        cursor: 'pointer',
      },
    },

    MuiButton: {
      sizeLarge: {
        minHeight: '3.5rem',
        fontSize: '1rem',
      },
    },
  },
};
